<template>
	<div class="team-block">
		<div
			:style="teamColors"
			:title="team.name"
			class="text-truncate text-center h3 p-20"
		>
			{{ team.name }}
		</div>
		<div class="flex items-center pl-20 pr-20 pt-35 pb-35">
			<logo-icon :src="team.logo" medium />
			<div>
				<nuxt-link :to="`/profile/teams/edit/?id=${team.id}`" class="ml-20 button-light-blue opacity-hover">
					{{ $tc('components.teamButtonText') }} >
				</nuxt-link>
			</div>
		</div>
	</div>
</template>

<script>
import LogoIcon from './LogoIcon'

export default {
	name: 'Team',
	components: { LogoIcon },
	props: {
		team: {
			type: Object,
			required: true
		}
	},
	computed: {
		teamColors () {
			const teamBgColor = this.team.color || '#591493'
			const isWhiteBg = teamBgColor.toLowerCase() === '#ffffff'

			return {
				backgroundColor: teamBgColor,
				color: isWhiteBg ? '#000000' : '#ffffff',
				border: isWhiteBg ? '1px solid #f0f0f1' : 'none'
			}
		}
	}
}
</script>

<style lang="scss">
	.team-block {
		width: 340px;
		min-height: 260px;
		background-color: $content-bg;

		.team-block-body {
			padding: 24px;
		}
	}
</style>
